import React from 'react';
export function PaymentRequestsShimmer() {
  return <div className="space-y-6 animate-pulse" data-id="element-4225">
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-4226">
        <div className="h-6 w-56 bg-gray-200 rounded" data-id="element-4227" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-4228" />
      </div>
      {/* Tabs */}
      <div className="border-b border-gray-200 pb-0" data-id="element-4229">
        <div className="flex gap-8" data-id="element-4230">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="pb-4" data-id="element-4231">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-4232" />
            </div>)}
        </div>
      </div>
      {/* Form Content */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-4233">
        <div className="space-y-6" data-id="element-4234">
          {/* Amount section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4235">
            <div data-id="element-4236">
              <div className="h-4 w-20 bg-gray-200 rounded mb-2" data-id="element-4237" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-4238" />
            </div>
            <div data-id="element-4239">
              <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-4240" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-4241" />
            </div>
          </div>
          {/* Description */}
          <div data-id="element-4242">
            <div className="h-4 w-28 bg-gray-200 rounded mb-2" data-id="element-4243" />
            <div className="h-24 w-full bg-gray-200 rounded-md" data-id="element-4244" />
          </div>
          {/* Additional fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4245">
            {[1, 2, 3, 4].map(i => <div key={i} data-id="element-4246">
                <div className="h-4 w-32 bg-gray-200 rounded mb-2" data-id="element-4247" />
                <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-4248" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Action bar */}
      <div className="bg-white rounded-lg border border-gray-200 p-6 flex justify-between items-center" data-id="element-4249">
        <div className="h-4 w-96 bg-gray-200 rounded" data-id="element-4250" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-4251" />
      </div>
    </div>;
}